<!-- 定时管理描述表单 -->
<template>
     <el-form :model="handleControlForm" status-icon :rules="rules" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
        <el-form-item label="状态" prop="setting_power_on">
            <el-select v-model="handleControlForm.setting_power_on" clearable placeholder="请选择">
                <el-option
                    v-for="(v, i) in configData.status"
                    :key="i"
                    :label="v.label"
                    :value="v.value"
                    :disabled="v.disable">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="模式" prop="setting_mode">
            <el-select v-model="handleControlForm.setting_mode" clearable placeholder="请选择">
                <el-option
                    v-for="(v, i) in configData.pattern"
                    :key="i"
                    :label="v.label"
                    :value="v.value"
                    :disabled="v.disable">
                </el-option>
            </el-select>
        </el-form-item>
        <template v-if="controlType === 2">
            <el-form-item label="制热温度" prop="setting_heating_temperature">
                <el-input-number v-model="handleControlForm.setting_heating_temperature" controls-position="right" :precision="1" :step="0.1" :min="16" :max="30"></el-input-number>&nbsp;&nbsp;°C
            </el-form-item>
            <el-form-item label="制冷温度" prop="setting_cooling_temperature">
                <el-input-number v-model="handleControlForm.setting_cooling_temperature" controls-position="right" :precision="1" :step="0.1" :min="16" :max="30"></el-input-number>&nbsp;&nbsp;°C
            </el-form-item>
        </template>
        <template v-if="controlType === 1">
            <el-form-item label="设温" prop="setting_temperature">
                <el-input-number v-model="handleControlForm.setting_temperature" controls-position="right" :precision="1" :step="0.1" :min="16" :max="30"></el-input-number>&nbsp;&nbsp;°C
            </el-form-item>
             <el-form-item label="风速" prop="setting_speed">
                <el-select v-model="handleControlForm.setting_speed" clearable placeholder="请选择">
                    <el-option
                        v-for="(v, i) in configData.windSpeed"
                        :key="i"
                        :label="v.label"
                        :value="v.value"
                        :disabled="v.disable">
                    </el-option>
                </el-select>
            </el-form-item>
        </template>
       <el-form-item label="锁定" prop="setting_key_lock">
            <el-select v-model="handleControlForm.setting_key_lock" clearable placeholder="请选择">
                <el-option
                    v-for="(v, i) in configData.lock"
                    :key="i"
                    :label="v.label"
                    :value="v.value"
                    :disabled="v.disable">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="来电启动" prop="setting_op_at_acback">
            <el-select v-model="handleControlForm.setting_op_at_acback" clearable placeholder="请选择">
                <el-option
                    v-for="(v, i) in configData.DDGK"
                    :key="i"
                    :label="v.label"
                    :value="v.value"
                    :disabled="v.disable">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="通风模式" prop="setting_allow_ventilation">
            <el-select v-model="handleControlForm.setting_allow_ventilation" clearable placeholder="请选择">
                <el-option
                    v-for="(v, i) in configData.windMode"
                    :key="i"
                    :label="v.label"
                    :value="v.value"
                    :disabled="v.disable">
                </el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import { CLUSTERMANA } from '@/api/configData.js'
import Service from '@/api/Service'

export default {
    name:  'CmpControlForm',
    props: ["index", "parentData"],
    inject: ["reload"],
    data() {
        return {
            handleControlForm: {
                setting_power_on: '',             //  状态
                setting_mode: '',            //  模式
                setting_heating_temperature: '',         //  制热温度
                setting_cooling_temperature: '',        //  制冷温度
                setting_speed: '',          //  风速
                setting_temperature: '',     //  设温
                setting_key_lock: '',           //  锁定

                setting_op_at_acback: '',             // 来电启动   
                // setting_temperature_dl: '',    //  温度下限
                // setting_temperature_ul: '',  //  温度上限
                setting_allow_ventilation: '',   //  通风模式
            },
            rules: {},
            configData: CLUSTERMANA,
        };
    },
    computed: {
        ...mapGetters(["timeDesc","settingTime", "timeControlMeters", 'timeControlForm']),
        controlType() {
            return this.timeDesc.devtype
        }
    },
    watch: {
        index(newVal, oldVal) {
            if(newVal == 5 && oldVal ==4 ) {
                // 保存
                this.next()
            }
        },
        parentData(newVal) {
            this.handleControlForm = Object.assign(this.handleControlForm, newVal)
        }
    },
    created() {
        this.handleControlForm = Object.assign(this.handleControlForm, this.parentData)
    },
    
    methods: {
        next() {
            
            this.$store.dispatch("setControlForm", this.handleControlForm).then(res=>{
                this.addTimer();
            })
        },
        async addTimer() {
            let params = Object.assign({}, this.timeDesc);  //  定时描述
            params.timerkind = this.timeDesc.timerkind[this.timeDesc.timerkind.length-1];   //  只保留最后一级ID
            params.timer_time = this.settingTime;  //  定时时间
            params.timer_control_dev = this.timeControlMeters;   //  控制对象
            params.timer_control_value = this.fmtData(); //  控制参数
            let data
            if(params.oid > 0) {
                // 修改
                data = await Service.editTimer(params);
            }else{
                // 新增
                data = await Service.addTimer(params);
            }
            if(data) {
                this.$message({
                    type: "success",
                    message: "操作成功"
                })
                this.$router.push('/timing')
            }
        },
        fmtData(){
            let arr = [];
            let _t = this;
            for (const key in this.handleControlForm) {
                const element = _t.handleControlForm[key];
                let obj = {}
                obj["N"] = key
                if(element == '') {
                    // obj["V"] = "255"
                }else{
                    obj["V"] = element
                }
                arr.push(obj);
            }
            return arr
        }
    }
}

</script>
<style lang='less' scoped>

</style>